<div
  class="tooltip-container"
  (mouseenter)="showTooltip()"
  (mouseleave)="hideTooltip()"
>
  <ng-content></ng-content>
  <div
    class="tooltip"
    [class.visible]="isVisible"
    [class.dark]="variant === 'dark'"
    [class.light]="variant === 'light'"
    [class.top]="position === 'top'"
    [class.right]="position === 'right'"
    [class.bottom]="position === 'bottom'"
    [class.left]="position === 'left'"
    [class.tip-top]="tip === 'top'"
    [class.tip-bottom]="tip === 'bottom'"
    [class.tip-center]="tip === 'center'"
    [class.tip-left]="tip === 'left'"
    [class.tip-right]="tip === 'right'"
  >
    <hyperkit-typography variant="body" size="md" color="inherit">{{
      text
    }}</hyperkit-typography>
    <div class="arrow"></div>
  </div>
</div>
